export class APIErrors extends Error{
    constructor(message: string){
        super(message);
        this.errorCode = 0;
    }
    errorCode : number;
}
